import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from 'ngx-auth';
import { TokenStorage } from './token-storage.service';
import { AppConfig } from '../app.config';
import { LoginResponse, User } from './authentication.model';
import { LocalUtils } from '../restricted/restricted.utils';

import 'rxjs/add/operator/map'
import 'rxjs/add/operator/do'

@Injectable()
export class AuthenticationService implements AuthService {

  constructor(
    private http: HttpClient,
    private tokenStorage: TokenStorage,
    private config: AppConfig
  ) { }

  public isAuthorized(): Observable<boolean> {

    let accessToken = this.tokenStorage
      .getAccessToken();

    return accessToken.map(token => !!token);
  }

  public getAccessToken(): Observable<string> {
    return this.tokenStorage.getAccessToken();
  }

  public refreshToken(): Observable<User> {

    return this.tokenStorage
      .getUserToken()
      .switchMap((refreshToken: User) => {
        return this.http.post(this.config.apiUrl + '/authentication/login', { refreshToken });
      })
      .do(this.saveAccessData.bind(this))
      .catch((err) => {
        this.logout();

        return Observable.throw(err);
      });
  }

  changePassword(email: string, oldPassword: string, newPassword: string) {
    let headers = this.createAuthorizationHeader();
    var patch = <any>{}
    patch.email = email;
    patch.uuidUpdatePassword = oldPassword;
    patch.password = newPassword;

    return this.http.patch(this.config.apiUrl + '/authentication/password/reset', patch, { headers: headers })
    .map(this.extractData)
    .catch(this.handleError);
  }

  public refreshShouldHappen(response: HttpErrorResponse): boolean {
    return response.status === 401
  }

  public verifyTokenRequest(url: string): boolean {
    return url.endsWith('/refresh');
  }

  public register(data): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

    return this.http.post(this.config.apiUrl + '/authentication/register', data, { headers: headers });
  }

  public login(user: string, password: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
      .set('Authorization', "Basic " + btoa(user + ":" + password));

    return this.http.get(this.config.apiUrl + '/authentication/login', { headers: headers })
      .do((tokens: LoginResponse) => this.saveAccessData(tokens));
  }

  updatePassword(user: any, newPassword: string) {
    let headers = this.createContentHeader()
    if (user.id) {
      var patch = <any>{ id: user.id, uuidUpdatePassword: '123456789123456789123456789123456789' };
    } else {
      var patch = <any>{ id: 0, uuidUpdatePassword: user.uuidUpdatePassword };
    }
    if (newPassword && newPassword.trim().length > 0) {
      patch.password = newPassword;
    }
    if (user.firstAccessAt && user.firstAccessAt.trim().length > 0) {
      patch.firstAccessAt = user.firstAccessAt;
    }
    if (user.lastAccessAt && user.lastAccessAt.trim().length > 0) {
      patch.lastAccessAt = user.lastAccessAt;
    }

    return this.http.patch(this.config.apiUrl + '/authentication/user', patch, { headers: headers })
      .do((tokens: LoginResponse) => this.saveAccessData(tokens));
  }

  public logout(): void {
    this.tokenStorage.clear();
    localStorage.removeItem('user');
    location.reload(true);
  }

  private saveAccessData(response) {
    if (response && response.token) {
      this.tokenStorage
        .setAccessToken(response.token)
        .setUserToken(response);
    }
  }

  private extractData(res: Response) {
    let body = (<any>res).records;
    return body || {};
  }

  private handleError(error: Response | any) {
    return Observable.throw(error);
  }

  createAuthorizationHeader():HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', LocalUtils.decrypt(localStorage.getItem("token")));
  }

  createContentHeader(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
  }

}


// WEBPACK FOOTER //
// ./src/app/auth/authentication.service.ts